import type { ToolbarAction } from '@repo/commons/models'

export const DEFAULT_TOOLBAR_CONFIG: ToolbarAction[] = [
	{
		id: 'preview',
		type: 'preview',
		text: 'Preview',
		title: 'Preview'
	},
	{
		id: 'undo',
		type: 'button',
		icon: 'undo',
		title: 'Undo (Ctrl/Cmd + Z)',
		action: 'undo'
	},
	{
		id: 'redo',
		type: 'button',
		icon: 'redo',
		title: 'Redo (Ctrl/Cmd + Shift + Z)',
		action: 'redo'
	},
	{
		id: 'divider-0',
		type: 'divider',
		title: 'Divider'
	},
	{
		id: 'bold',
		type: 'button',
		icon: 'bold',
		title: 'Bold (Ctrl/Cmd + B)',
		markdownBefore: '**',
		markdownAfter: '**'
	},
	{
		id: 'italic',
		type: 'button',
		icon: 'italic',
		title: 'Italic (Ctrl/Cmd + I)',
		markdownBefore: '*',
		markdownAfter: '*'
	},
	{
		id: 'strikethrough',
		type: 'button',
		icon: 'strikethrough',
		title: 'Strikethrough (Ctrl/Cmd + Shift + S)',
		markdownBefore: '~~',
		markdownAfter: '~~'
	},
	{
		id: 'divider-1',
		type: 'divider',
		title: 'Divider'
	},
	{
		id: 'bullet-list',
		type: 'button',
		icon: 'bulletList',
		title: 'Bullet List',
		action: 'bulletList'
	},
	{
		id: 'numbered-list',
		type: 'button',
		icon: 'numberList',
		title: 'Numbered List',
		action: 'numberedList'
	},
	{
		id: 'quote',
		type: 'button',
		icon: 'quote',
		title: 'Quote',
		markdownBefore: '> ',
		markdownAfter: ''
	},
	{
		id: 'link',
		type: 'button',
		icon: 'link',
		title: 'Link (Ctrl/Cmd + K)',
		action: 'link'
	},
	{
		id: 'divider-2',
		type: 'divider',
		title: 'Divider'
	},
	{
		id: 'h1',
		type: 'button',
		icon: 'h1',
		title: 'Heading 1',
		markdownBefore: '# ',
		markdownAfter: ''
	},
	{
		id: 'h2',
		type: 'button',
		icon: 'h2',
		title: 'Heading 2',
		markdownBefore: '## ',
		markdownAfter: ''
	},
	{
		id: 'h3',
		type: 'button',
		icon: 'h3',
		title: 'Heading 3',
		markdownBefore: '### ',
		markdownAfter: ''
	},
	{
		id: 'divider-3',
		type: 'divider',
		title: 'Divider'
	},
	{
		id: 'image',
		type: 'image',
		icon: 'image',
		title: 'Upload Image'
	}
]

export const OUTPUT_OBJECT_VOICE_PROMPT_TOOLBAR_CONFIG: ToolbarAction[] = [
	{
		id: 'undo',
		type: 'button',
		icon: 'undo',
		title: 'Undo (Ctrl/Cmd + Z)',
		action: 'undo'
	},
	{
		id: 'redo',
		type: 'button',
		icon: 'redo',
		title: 'Redo (Ctrl/Cmd + Shift + Z)',
		action: 'redo'
	}
]
